import { c as _c } from "react/compiler-runtime";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { getRandomColorWithSeed } from "@/helpers/Helpers";
export default function GroupItemWrapper(t0) {
  const $ = _c(20);
  const {
    group,
    isActive,
    children,
    deactivateHover,
    onActiveGroupId
  } = t0;
  let t1;
  if ($[0] !== group.created_by?.banner1_color || $[1] !== group.created_by?.handle) {
    t1 = group.created_by?.banner1_color ?? getRandomColorWithSeed(group.created_by?.handle ?? "");
    $[0] = group.created_by?.banner1_color;
    $[1] = group.created_by?.handle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const banner1 = t1;
  let t2;
  if ($[3] !== group.created_by?.banner2_color || $[4] !== group.created_by?.handle) {
    t2 = group.created_by?.banner2_color ?? getRandomColorWithSeed(group.created_by?.handle ?? "");
    $[3] = group.created_by?.banner2_color;
    $[4] = group.created_by?.handle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const banner2 = t2;
  let t3;
  if ($[6] !== group.id || $[7] !== isActive || $[8] !== onActiveGroupId) {
    t3 = () => {
      if (isActive || !onActiveGroupId) {
        return;
      }
      onActiveGroupId(group.id);
    };
    $[6] = group.id;
    $[7] = isActive;
    $[8] = onActiveGroupId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onFilterClick = t3;
  let t4;
  if ($[10] !== deactivateHover || $[11] !== isActive) {
    t4 = () => {
      if (!isActive) {
        return "tw-border-iron-700 hover:tw-border-primary-300 tw-cursor-pointer";
      }
      if (deactivateHover) {
        return "hover:tw-border-yellow";
      } else {
        return "tw-border-primary-300 ";
      }
    };
    $[10] = deactivateHover;
    $[11] = isActive;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const getClasses = t4;
  const classes = getClasses();
  const t5 = `tw-bg-iron-900 tw-w-full tw-text-left tw-relative tw-border tw-border-solid tw-rounded-xl tw-transition tw-duration-300 tw-ease-out ${classes}`;
  const t6 = `linear-gradient(45deg, ${banner1} 0%, ${banner2} 100%)`;
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="tw-relative tw-w-full tw-h-7 tw-rounded-t-xl" style={{
      background: t6
    }} />;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== onFilterClick || $[17] !== t5 || $[18] !== t7) {
    t8 = <div><div onClick={onFilterClick} className={t5}>{t7}{children}</div></div>;
    $[15] = children;
    $[16] = onFilterClick;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}